export default __webpack_public_path__ + "static/media/empathy-map-template.ce6f6291.pdf";